
export async function runPlayerExtension(videojs, player, extension) {
    const extensionUrl = `${extension.ExtensionBasePath}extension.js`;
    let result;

    try {
        player.log(`Attempting to run player extension of type ${extension.ExtensionType} from URL ${extensionUrl}`);

        const { default: extensionFunc } = await import(/* webpackIgnore: true */ extensionUrl);

        result = extensionFunc(videojs, player, extension.Data);
        if (!isPromise(result)) {
            result = Promise.resolve();
        }
    } catch (err) {
        player.log(`Failed to run player extension of type ${extension.ExtensionType} from URL ${extensionUrl}`);
        result = Promise.reject(`${err.name}: ${err.message}`);
    }

    return result;
}

function isPromise(val) {
    return typeof val === 'object' && typeof val.then === 'function';
}